import type { CacheDescriptor } from '../store/schema/CacheDescriptor';

import type { ItemCache } from '../store/schema/ItemCache';

export function checkContainsDescriptor<T, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    descriptor: U,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): boolean {
    const descriptors = [...store.descriptors.values()];
    return descriptors.some(d => containsDescriptor(d, descriptor));
}
